module.exports = __webpack_public_path__ + "img/qrcode-1703.71130ad9.png";